import { h } from 'preact';
import * as BaseComp from 'components/pages/text/text.js';
import { accessNested } from 'utils/utils';
import Store from 'store/store';
import * as actions from 'store/actions';
import s from 'components/pages/text/text.sss';

export default class Text extends BaseComp.default {
	constructor(props) {
		super(props);

		this.state.loading = false;

		this.handleClick = this.handleClick.bind(this);
		this.observerCallback = this.observerCallback.bind(this);
	}

	componentDidMount() {
		super.componentDidMount();
		if (this.props.id === 'industryRoles') {
			this.observer = new IntersectionObserver(this.observerCallback, { threshold: [0.7] });
			const iframes = document.querySelectorAll('.iframe');
			iframes.forEach(iframe => {
				this.observer.observe(iframe);
			});
		}
	}

	componentWillUnmount() {
		if (this.observer) {
			const iframes = document.querySelectorAll('.iframe');
			iframes.forEach(iframe => {
				this.observer.unobserve(iframe);
			});
			this.observer.disconnect();
		}
	}

	observerCallback(entries) {
		const activePage = Store.get().activePage.id;
		if (activePage !== this.props.id) {
			return;
		}
		entries.forEach(e => {
			const iframeTitle = (e.target.getAttribute('title') || '').replaceAll(' ', '');
			if (e.isIntersecting && !this.state[`${iframeTitle}tracked`]) {
				Store.emit('POWSTER_GA_EVENT_TRACK', 'industry-role-view', 'industryRoles', iframeTitle);
				this.setState({ [`${iframeTitle}tracked`]: true });
			}
		});
	}

	renderBody() {
		const base = super.renderBody();
		const { data, id } = accessNested(Store.get(), 'activePage');
		const { bookmarksLogo } = data;

		if (bookmarksLogo && id === 'activities') {
			return (
				<div class={s.body}>
					<div class="bookmarks-logo"><img src={bookmarksLogo} /></div>
					<h1 class="heading">ACTIVITIES</h1>

					<div class="paragraph">
					These activities are adaptable for children of different ages, and can be used to make reading more physically active and part of a daily routine. 
					</div>

					<h2 class="subheading">Create a Book Nook</h2>
					<div class="paragraph">
						<p>Create a quiet secluded space in your home  using pillows, blankets, and other odds and ends you find! Once you’ve built it, snuggle inside and read a book!</p>
					</div>

					<h2 class="subheading">Ready, Set, Action</h2>
					<div class="paragraph">
						<p>Act out your favorite part of the story. (Make it even more interesting and dress up as the character)</p>
					</div>

					<h2 class="subheading">Draw a Character</h2>
					<div class="paragraph">
						<p>Grab some crayons, markers, pencils, and paper and get your creative juices flowing. Draw a picture of your favorite character or scene from a book.</p>
					</div>

					<h2 class="subheading">Re-read a Book</h2>
					<div class="paragraph">
						<p>Pick a favorite book from the list and re-read it! Did you notice anything new this time around? You can also re-read the book to or with someone else; your siblings, parents, grandparents, relatives, or friends (in person or virtually).</p>
					</div>  

					<h2 class="subheading">Walking Storybook </h2>
					<div class="paragraph">
						<p>Print out a leveled storybook and hang each page (in order!) on the walls of a room, at eye-level for the child. Then, have them take a walking journey around the room to read the book! If the child has read the book before, hand the pages to them, out of order, and have them build the correct sequence on the floor by finding and putting the pages in order. </p>
					</div>  

					<h2 class="subheading">Modeling Clay Writing</h2>
					<div class="paragraph">
						<p>Use modeling clay  to form new words you learned and characters from the story.</p>
					</div>  

					{this.downloadBtn()}

					<h1 class="heading">RESOURCES</h1>

					<a href="https://docs.google.com/document/d/1zv7DiiyOHRrwTjEbrWbkE0UvJcZ0qDGCu9lhE1AHdhE/edit" class="resource-link" target="_blank">ALSC Supporting Diverse Communities Toolkit</a>
					<p class="paragraph">This toolkit is a continually updated resource to help children’s library workers support children and families through times of unrest and uncertainty.</p>

					<a href="http://www.ala.org/alsc/publications-resources/book-lists" target="_blank">Booklists Created by ALSC Library Professionals</a>
					<p class="paragraph">The Association for Library Service to Children promotes reading and books through recommendations, compilations of lists, and related services. ALSC booklists are created as a resource for children's library professionals to share with patrons. Parents and caregivers are encouraged to explore these titles to find resources that may match or spark their child's interest.</p>

					<a href="https://www.bcala.org/booklists" target="_blank">Booklists Created by BCALA Librarians</a>
					<p class="paragraph">The Black Caucus of the American Library Association promotes nationwide awareness and use of Children and Young Adult literature through programming, publications, and outreach activities to students, parents, librarians, educators, & scholars. BCALA provides vital resources to children and their caregivers to help promote reading and emergent literacy.</p>

					<a href="http://www.ala.org/alsc/publications-resources/look-to-libraries" target="_blank">#LooktoLibraries</a>
					<p class="paragraph">ALSC has created resources to help families navigate life during the pandemic. Look to Libraries includes tip sheets about talking with children about COVID-19 and managing the use of digital resources.</p>

					<a href="https://grassrootscommunityfoundation.org/1000-black-girl-books-resource-guide/" target="_blank">#1000BlackGirlBooks</a>
					<p class="paragraph">This resource guide was created in direct response to the multiple requests made by educators, parents and students. Like Marley Dias, so many of you have asked for books with black girls as the main characters. And because of you, we have received thousands of books. Here, we are sharing with you the first 1000 titles. This resource includes words of welcome from Marley Dias, Creator of the #1000BlackGirlBooks campaign.</p>
				</div>
			);
		} else {
			return base;
		}
	}

	forceDownload(blob, filename) {
		const anchor = document.createElement('a');
		anchor.style.display = 'none';
		anchor.href = window.URL.createObjectURL(blob);
		anchor.setAttribute('download', filename);
		document.body.appendChild(anchor);

		anchor.click();
		window.URL.revokeObjectURL(anchor.href);
		document.body.removeChild(anchor);
	}

	handleClick() {
		const { downloadButton } = accessNested(this.props, 'activePage.data');
		const url = downloadButton.href;
		const filename = 'workbook.pdf';

		this.setState({ loading: true });

		fetch(url, {
			headers: new Headers({ Origin: window.location.origin }),
			mode: 'cors'
		}).then(response => response.blob())
			.then(blob => this.forceDownload(blob, filename))
			.then(() => this.setState({ loading: false }))
			.catch(error => {
				console.log(error);
				() => this.setState({ loading: false });
			});

		Store.emit(actions.POWSTER_GA_EVENT_TRACK, 'download_workbook', 'bookmarks', '-');
	}

	downloadBtn() { 
		const { downloadButton } = accessNested(this.props, 'activePage.data');

		const { loading } = this.state;

		if (downloadButton) {
			return (
				<button
					class={s.download}
					ariaLabel={downloadButton.ariaLabel}
					title={downloadButton.title}
					onClick={this.handleClick}
				>
					{loading ? <span class={s.spinner} /> : <span>{downloadButton.label}</span>}
				</button>
			);	
		}
	}
}

export const verticallyCenter = BaseComp.verticallyCenter;
export const dependencies = BaseComp.dependencies;
